module.exports = __webpack_public_path__ + "img/cursor-select.e01061d4.svg";